import React, { Component } from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'Collect Customer Feedback On Your Website | Canny';
const Description =
  "Create your customer feedback board and start collecting customers' product feedback in minutes! Get started for free.";
const Image = 'https://canny.io/images/canny-social.png';
const CollectFeedbackUrl = 'https://canny.io/features/collect-feedback';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${CollectFeedbackUrl}#webpage`,
    url: CollectFeedbackUrl,
    name: 'Collect Feedback - Canny',
    description:
      "Canny's feedback collection helps teams capture, centralize, and analyze user feedback from multiple channels.",
    inLanguage: 'en',
    about: { '@id': 'https://canny.io/#app' },
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createWebApplicationItemList(
    `${CollectFeedbackUrl}#methods`,
    'Feedback Collection Methods',
    [
      {
        name: 'Public & Private Boards',
        description:
          'Customizable feedback boards where users can post requests and ideas, publicly or privately.',
      },
      {
        name: 'In-App Widgets',
        description: 'Capture user feedback directly inside your app at the point of experience.',
      },
      {
        name: 'Integrations',
        description:
          'Connect with tools like Intercom, Zendesk, Slack, and Help Scout to consolidate all feedback into Canny.',
      },
      {
        name: 'API',
        description: "Leverage Canny's API to push and manage feedback from any custom source.",
      },
    ],
  ),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Features', item: 'https://canny.io/features' },
    { name: 'Collect Feedback', item: CollectFeedbackUrl },
  ]),
]);

export default class LandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: CollectFeedbackUrl },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}>
        <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
      </Helmet>
    );
  }
}
